// removed by extract-text-webpack-plugin
module.exports = {"projectVisibility":"_3bFzo94hDbHahFb_","title":"_2orjehLKSfAm8JMM","text":"JhvAKghJeGHAu_1P","controls":"NNo11Nk_oQqqrJvX","cancel":"_18r0zXxoFJpHkKoi","delete":"YThokTdA5x4sMv3H"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Popups/ProjectVisibilityCheckBeforeShare/ProjectVisibilityCheckBeforeShare.pcss
// module id = 497
// module chunks = 1